module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("wat")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43330f16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Callback/index.vue
// module id = 712
// module chunks = 1